
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.257 11.414a.3.3 0 01.3-.3h.598c.596-.006 1.068-.16 1.414-.464.351-.303.527-.742.527-1.317 0-.554-.147-.983-.44-1.286-.287-.309-.729-.463-1.325-.463-.522 0-.95.151-1.286.455a1.447 1.447 0 00-.48.875c-.026.164-.157.299-.323.299h-1.34a.28.28 0 01-.287-.3c.044-.48.197-.923.457-1.33.32-.49.762-.87 1.326-1.141.57-.277 1.206-.416 1.909-.416 1.16 0 2.07.293 2.731.879.666.58.998 1.39.998 2.428 0 .521-.167 1.014-.503 1.477-.33.458-.758.804-1.286 1.038.64.219 1.124.562 1.454 1.03.335.469.503 1.028.503 1.678 0 1.043-.36 1.874-1.078 2.491-.713.618-1.653.927-2.82.927-1.117 0-2.033-.299-2.746-.895-.64-.535-.993-1.228-1.06-2.08a.283.283 0 01.29-.3h1.34c.166 0 .297.136.321.3.055.376.219.691.49.946.346.32.81.48 1.39.48.601 0 1.075-.16 1.421-.48.346-.32.52-.783.52-1.39 0-.612-.182-1.083-.544-1.413-.362-.33-.9-.495-1.613-.495h-.558a.3.3 0 01-.3-.3v-.933zM13.127 17.814a.3.3 0 01-.3-.3V6.486a.3.3 0 01.3-.3h3.134c1.028 0 1.938.229 2.731.687a4.675 4.675 0 011.853 1.949c.437.84.655 1.804.655 2.89v.584c0 1.102-.221 2.07-.663 2.906a4.596 4.596 0 01-1.877 1.933c-.809.453-1.738.679-2.787.679h-3.046zm1.72-9.999v8.386h1.318c1.06 0 1.872-.33 2.436-.99.57-.666.86-1.62.87-2.86v-.647c0-1.261-.274-2.225-.822-2.89-.548-.666-1.344-.999-2.388-.999h-1.413z"}})])
          )
        }
      }
    